const appSettings = {
    pagination: 100,
    // Postgres search (40.02 §5.2): rows fetched and ranked, rows returned
    searchCandidateLimit: 200,
    searchResultLimit: 100,
    clientVersion: 'V2.21.1'
};

export default appSettings;